module.exports = __webpack_public_path__ + "static/bountycontestbtn-513b056faf756dfee8ba01419a1c67eb.png";